import React from 'react';
import Skeleton from 'react-loading-skeleton'; // Import du Skeleton
import 'react-loading-skeleton/dist/skeleton.css';
import FormattedDate from '../components/FormattedDate';

const TestimonialBloc = ({ testimonials, status,title,type }) => {
    const data=type==="pro" ? testimonials?.slice(0, 5) : testimonials.avis
    // console.log({data})
    // Affichage du Skeleton pendant le chargement
    if (status === 'loading') {
        return (
            <div className="container space-bloc">
                <div className="row bottom-align">
                    <div className="col-md-6">
                        <Skeleton height={30} width="50%" style={{ marginBottom: '10px' }} />
                    </div>
                </div>
                <div className="row">
                    {Array(4).fill(0).map((_, index) => (
                        <div className="col-md-3" key={index}>
                            <Skeleton height={20} width="30%" style={{ marginBottom: '5px' }} />
                            <Skeleton height={100} width="100%" />
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    // Si les témoignages existent et contiennent des avis
    if (testimonials && data?.length > 0) {
        return (
            <div className="container space-bloc">
                <div className="row bottom-align">
                    <div className="col-md-6">
                        <h2 className='grey500'>{title}</h2>
                    </div>
                </div>
                <div className="row ">
                    {data?.map((avi, index) => (
                        <div className={type==="pro"?'col-12 col-sm-12 col-md mt-32':"col-md-3 mt-32"} key={index}>
                            <div className="d-flex flex-column justify-content-between h-100">
                            <div><div className="rating">
                                {avi.rating}
                                <img src="/star.png" className="starating ml-8" alt="Star" />
                            </div>
                            <p className='body grey66'>{avi.review}</p>
                                </div>  
                            <div className='userreview'>
                            <div 
                                className="avataruser" 
                                style={{
                                backgroundImage: `url(${process.env.REACT_APP_FILE_URL}/${avi.avatar})`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat'
                                }}
                            ></div>
                                {/* <img src={`${process.env.REACT_APP_FILE_URL}/${avi.avatar}`} className="avataruser" alt="avatar" /> */}
                                <div className='detailreview'>
                                        <div className='body grey500'>{avi.name}, {avi.job}</div>
                                        <div className='user-date legend grey66'><FormattedDate date={avi.review_date} /></div>
                                </div>
                            </div>  
                            </div>
                            
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    // Si testimonials est vide ou ne contient pas d'avis
    return null;
};

export default TestimonialBloc;
